import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import {
  StSiteMasterGlanceSection,
  StSiteMasterSectionTitle,
  StSiteMasterStat,
  StSiteMasterStatGrid,
  StSiteMasterStatLabel,
  StSiteMasterStatValue,
} from 'components/SiteMaster/SiteMaster.styles';
import { getFieldValue, useSiteMasterRouteFields } from 'components/SiteMaster/utils';
import { getGlanceMetrics } from './SiteInfoHelper';

type SiteInfoProps = ComponentProps & {
  fields: {
    sectionTitle?: Field<string>;
    activeStudiesText?: Field<string>;
    enrollingNowText?: Field<string>;
    yearsActiveText?: Field<string>;
    languagesSpokenText?: Field<string>;
  };
};

const SiteInfo = (props: SiteInfoProps): JSX.Element | null => {
  const routeFields = useSiteMasterRouteFields();
  const { fields } = props;
  const metrics = getGlanceMetrics(routeFields, fields);
  const sectionTitle = getFieldValue(fields.sectionTitle).trim();

  if (!metrics.length) {
    return null;
  }

  return (
    <StSiteMasterGlanceSection id="site-at-a-glance">
      {sectionTitle && (
        <StSiteMasterSectionTitle>
          <Text field={fields.sectionTitle} />
        </StSiteMasterSectionTitle>
      )}
      <StSiteMasterStatGrid>
        {metrics.map(
          (metric) =>
            metric.value &&
            metric.labelField && (
              <StSiteMasterStat key={metric.id}>
                <StSiteMasterStatValue>{metric.value}</StSiteMasterStatValue>
                <StSiteMasterStatLabel>
                  <Text field={metric.labelField} />
                </StSiteMasterStatLabel>
              </StSiteMasterStat>
            )
        )}
      </StSiteMasterStatGrid>
    </StSiteMasterGlanceSection>
  );
};

export default SiteInfo;
